export type AnalyticsEnv = {
  gaMeasurementId: string | null;
  clarityProjectId: string | null;
  adminGaMeasurementId: string | null;
  adminClarityProjectId: string | null;
  metaPixelId: string | null;
};

export const analyticsEnabled =
  process.env.NODE_ENV === "production" ||
  process.env.NEXT_PUBLIC_ANALYTICS_DEBUG === "true";

export function getAnalyticsEnv(): AnalyticsEnv {
  return {
    gaMeasurementId: normalizeGaId(process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID),
    clarityProjectId: normalize(process.env.NEXT_PUBLIC_CLARITY_ID),
    adminGaMeasurementId: normalizeGaId(process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID_ADMIN),
    adminClarityProjectId: normalize(process.env.NEXT_PUBLIC_CLARITY_ID_ADMIN),
    metaPixelId: normalizeMetaPixelId(process.env.NEXT_PUBLIC_META_PIXEL_ID),
  };
}

function normalize(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

function normalizeGaId(value: string | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  if (!/^G-[A-Z0-9]+$/i.test(trimmed)) {
    if (typeof window !== "undefined") {
      console.warn("NEXT_PUBLIC_GA_MEASUREMENT_ID has an invalid format, GA4 disabled");
    }
    return null;
  }
  return trimmed;
}

function normalizeMetaPixelId(value: string | undefined): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  if (!/^[0-9]{15,16}$/.test(trimmed)) {
    if (typeof window !== "undefined") {
      console.warn("NEXT_PUBLIC_META_PIXEL_ID has an invalid format, Meta Pixel disabled");
    }
    return null;
  }
  return trimmed;
}
